//#region
import axios from 'axios';
import { url, endPoint } from '../urls';
//#endregion

export function getDatasets(params) {
    let _url = url.backendHost + endPoint.datasets.getList;
    return axios.get(_url, { params });
}

//Beacause getDatasetsList Api was already used in the getDatasets, we have used getDatsets API in getDatasetsList
export function getDatasetsList(params) {
    let _url = url.backendHost + endPoint.datasets.get;
    return axios.get(_url, { params });
}

export function addDatasets(params) {
    let _url = url.backendHost + endPoint.datasets.add;
    delete params._id
    return axios.post(_url, params);
}

export function updateDatasets(params) {
    let _url = url.backendHost + endPoint.datasets.update;
    return axios.put(_url, params);
}

export function deleteDatasets(params) {
    let _url = url.backendHost + endPoint.datasets.delete;
    return axios.post(_url, params);
}

export function getDataSetDetails(params) {
    let _url = url.backendHost + endPoint.datasets.getDataSetDetails;
    return axios.get(_url, { params });
}

export function refreshDataSetsWithAthena(params) {
    let _url = url.backendHost + endPoint.datasets.refreshDataSetsWithAthena;
    return axios.post(_url, params);
}

export function addJoinDataSet(params) {
    let _url = url.backendHost + endPoint.datasets.addJoinDataSet;
    return axios.post(_url, params);
}

export function addJoinDataSetNew(params) {
    let _url = url.backendHost + endPoint.datasets.addJoinDataSetNew;
    return axios.post(_url, params);
}

export function updateDataSetJoin(params) {
    let _url = url.backendHost + endPoint.datasets.updateDataSetJoin;
    return axios.put(_url, params);
}

export function updateDataSetJoinNew(params) {
    let _url = url.backendHost + endPoint.datasets.updateDataSetJoinNew;
    return axios.put(_url, params);
}

export function getAllDataFromAthena(params) {
    let _url = url.backendHost + endPoint.datasets.getAllDataFromAthena;
    return axios.get(_url, { params });
}
export function createJoinDatasetProps(params) {
    let _url = url.backendHost + endPoint.datasets.createJoinDatasetProps;
    return axios.post(_url, params);
}

export function resyncJoinDataset(params) {
    let _url = url.backendHost + endPoint.datasets.resyncJoinDataset;
    return axios.put(_url, params);
}

export function updateAthenaDataSet(params) {
    let _url = url.backendHost + endPoint.datasets.updateAthenaDataSet;
    return axios.put(_url, params);
}

export function getAllDataSetsWOAuth(params) {
    let _url = url.backendHost + endPoint.datasets.getAllDataSetsWOAuth;
    return axios.get(_url, { params });
}
export function addAthenaDataSetWithFilter(params) {
    let _url = url.backendHost + endPoint.datasets.addAthenaDataSetWithFilter;
    return axios.post(_url, params);
}
export function getDatasetByName(params) {
    let _url = url.backendHost + endPoint.datasets.getDatasetByName;
    return axios.post(_url, params);
}
export function updateJoinDataSetFields(params) {
    let _url = url.backendHost + endPoint.datasets.updateJoinDataSetFields;
    return axios.put(_url, params);
}